var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAppVersion, getPlatformType, isDianpingAppOrWebview, getSystemType, SystemType } from '@nibfe/mkt-env-api';
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
import { getUserInfo } from '@nibfe/mkt-user-api';
import { PlatformType } from '@nibfe/mkt-env-api/src/libs/enum';
import { isXHSWebView } from "@msi/channel-basic";
const CLIENT_TYPE = {
    UNKNOWN: 0,
    MT_APP: 1,
    DP_APP: 2,
    MINI_MT: 3,
    MINI_DP: 4,
    MINI_TICKET: 5,
    MINI_KS: 6,
    MINI_KS_QUICK: 7,
    H5: 8,
    HARMONY: 9
};
const OS_TYPE = {
    UNKNOWN: 0,
    ANDROID: 1,
    IOS: 2,
    HARAMONYOS: 3
};
export var UtmMedium;
(function (UtmMedium) {
    UtmMedium["android"] = "android";
    UtmMedium["iphone"] = "iphone";
    UtmMedium["wxProgram"] = "WEIXINPROGRAM";
    UtmMedium["harmony"] = "HarmonyOS";
})(UtmMedium || (UtmMedium = {}));
export const getCommonInfo = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const appVersion = getAppVersion();
    const systemType = getSystemType();
    const platformType = getPlatformType();
    const platform = isDianpingAppOrWebview() ? 2 : 1;
    const lbsResult = yield getLBSInfo({
        needLocation: true,
        sceneToken: 'dd-58025397509f0826'
    });
    ;
    const userInfo = yield getUserInfo();
    console.log(appVersion, systemType, lbsResult, userInfo, platformType, platform, 'commonInfo');
    let uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (window === null || window === void 0 ? void 0 : window.inEditor) {
        uuid = 'F535010AC76E6B0D6C0EC4C59B5DB92A7B959FA923F1940CE2D4F21E02ADEE95';
    }
    const source = isXHSWebView ? (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams : userInfo;
    return {
        version: appVersion !== null && appVersion !== void 0 ? appVersion : '12.9.200',
        client: isXHSWebView ? 8 : isHarmonyOS() ? 5 : (systemType === null || systemType === void 0 ? void 0 : systemType.toLowerCase()) === 'ios' ? 1 : 2,
        cityId: lbsResult === null || lbsResult === void 0 ? void 0 : lbsResult.homeSelectedCity,
        userId: (_b = source === null || source === void 0 ? void 0 : source.userId) !== null && _b !== void 0 ? _b : '-1',
        token: (_c = source === null || source === void 0 ? void 0 : source.token) !== null && _c !== void 0 ? _c : '-1',
        uuid: uuid,
        platform,
        clientType: getClientType(),
        osType: getOSType()
    };
});
function isHarmonyOS() {
    return getSystemType() === SystemType.harmony || /HarmonyOS/.test(navigator.userAgent);
}
function getOSType() {
    var _a;
    // 优先检查是否为鸿蒙系统
    if (isHarmonyOS()) {
        return OS_TYPE.HARAMONYOS;
    }
    // 其他系统类型判断
    switch ((_a = getSystemType()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
        case 'ios':
            return OS_TYPE.IOS;
        case 'android':
            return OS_TYPE.ANDROID;
        default:
            return OS_TYPE.UNKNOWN;
    }
}
export const getUtmMedium = () => {
    if (isHarmonyOS()) {
        return UtmMedium.harmony;
    }
    const system = getSystemType();
    switch (system) {
        case SystemType.android:
            return UtmMedium.android;
        case SystemType.ios:
            return UtmMedium.iphone;
        default:
            return UtmMedium.iphone;
    }
};
function getClientType() {
    if (isHarmonyOS()) {
        return CLIENT_TYPE.HARMONY;
    }
    switch (getPlatformType()) {
        case PlatformType.mtApp:
        case PlatformType.mtAppWebView:
            return CLIENT_TYPE.MT_APP;
        case PlatformType.dpApp:
        case PlatformType.dpAppWebView:
            return CLIENT_TYPE.DP_APP;
        case PlatformType.mtMinaWebview:
            return CLIENT_TYPE.MINI_MT;
        case PlatformType.dpMinaWebview:
            return CLIENT_TYPE.MINI_DP;
        case PlatformType.mtTicketMinaWebview:
            return CLIENT_TYPE.MINI_TICKET;
        case PlatformType.ksMinaWebview:
            return CLIENT_TYPE.MINI_KS;
        case PlatformType.pc:
        case PlatformType.default:
            return CLIENT_TYPE.H5;
        default:
            return CLIENT_TYPE.H5;
    }
}
